import { AxiosError } from 'axios'

export function handleEditLockErrorAndNotify(error: unknown, workplanId?: number): boolean {
  const axiosError = error as AxiosError<any>
  const status = axiosError?.response?.status
  if ((status === 403 || status === 409) && Number.isFinite(workplanId)) {
    const ownerName = axiosError?.response?.data?.error?.details?.editLockOwnerName as string | undefined
    const event = new CustomEvent('workplan_lock_forced', {
      detail: { workplanId: Number(workplanId), newOwnerName: ownerName }
    })
    window.dispatchEvent(event)
    return true
  }
  return false
}

export function handleProcessEditLockErrorAndNotify(error: unknown, processId?: number): boolean {
  const axiosError = error as AxiosError<any>
  const status = axiosError?.response?.status
  if ((status === 403 || status === 409) && Number.isFinite(processId)) {
    const ownerName = axiosError?.response?.data?.error?.details?.editLockOwnerName as string | undefined
    const event = new CustomEvent('process_lock_forced', {
      detail: { processId: Number(processId), newOwnerName: ownerName }
    })
    window.dispatchEvent(event)
    return true
  }
  return false
}


